/** Top bar: planning name (+ ProjectLibre lock), offline and saving state, user menu. */
import clsx from 'clsx';
import { Lock, Menu, WifiOff } from 'lucide-react';
import { Link } from 'react-router';
import { useOnline } from '../lib/online.js';
import styles from './AppShell.module.css';
import { SavingIndicator } from './SavingIndicator.js';
import { usePlanningSummary } from './usePlanningSummary.js';
import { UserMenu } from './UserMenu.js';

export function TopBar({ onMenu, menuOpen }: { onMenu: () => void; menuOpen: boolean }) {
  const planning = usePlanningSummary();
  const online = useOnline();

  return (
    <header className={styles.topbar}>
      <button type="button" className={clsx('btn btn-ghost btn-icon', styles.menuButton)} onClick={onMenu} aria-label="Menu" aria-expanded={menuOpen}>
        <Menu aria-hidden="true" />
      </button>
      <Link to="/" className={styles.topBrand} aria-label="TransectLibre – startpagina">
        <img src="/brand/transect-icon.svg" alt="" width={30} height={30} />
      </Link>
      <div className={styles.planningName}>
        <span className="truncate">{planning?.name ?? 'TransectLibre'}</span>
        {planning?.editLock && (
          <span className="badge badge-warning" title="Wordt bewerkt in ProjectLibre – alleen lezen">
            <Lock size={12} aria-hidden="true" />
            <span className={styles.hideOnPhone}>Alleen lezen</span>
          </span>
        )}
      </div>
      <div className={styles.topActions}>
        {!online && (
          <span className={styles.offline} role="status" title="Geen internetverbinding: wat je ziet kan verouderd zijn">
            <WifiOff aria-hidden="true" />
            <span>Offline</span>
          </span>
        )}
        <SavingIndicator />
        <UserMenu />
      </div>
    </header>
  );
}
